// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
/**
 * TagService manages tags and their associations with locations. Access is controlled by the TAG_MANAGE ACL.
 */
export const TagService = {
    CreateTag(fn, req) {
        return fn(`/tag/v2/tags`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * GetTag returns a tag or smart tag by id.
     */
    GetTag(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/tag/v2/tags/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
    UpdateTag(fn, req) {
        return fn(`/tag/v2/tags`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteTag(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/tag/v2/tags/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
    /**
     * Fetches all tags assigned to a group or org.
     */
    ListTags(fn, req) {
        return fn(`/tag/v2/tags?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListTagVersion returns all versions of a tag.
     */
    ListTagRevision(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/tag/v2/tags/${req["id"]}/revisions?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
};
